import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function NationalCharcoalSurvey() {
  return (
    <div className="art-page">
      <SEO
        title="National Charcoal Survey for Uganda"
        description="CIRCODU implemented the National Charcoal Survey for Uganda to generate comprehensive, nationally representative data on charcoal production, trade, consumption, and pricing."
        keywords="charcoal, survey, Uganda, energy data, charcoal production, charcoal trade, charcoal consumption, charcoal pricing, national survey, CIRCODU, charcoal economy, energy policy, deforestation, clean cooking, sustainable energy, charcoal efficiency, evidence-based policy, national energy data, charcoal market, charcoal quality testing, road traffic surveys, cross-border trade surveys"
        url="/National-Charcoal-Survey-for-Uganda"
        datePublished="2016-06-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              National Charcoal Survey for Uganda
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              June 01, 2016
            </div>
            <h1 className="art-title">National Charcoal Survey for Uganda</h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                Between late 2015 and mid-2016, CIRCODU implemented the{" "}
                <strong>National Charcoal Survey for Uganda</strong> — one of
                the most extensive energy data collection exercises ever
                conducted in the country. Commissioned by the Government of
                Uganda's{" "}
                <strong>
                  Ministry of Energy and Mineral Development (MEMD)
                </strong>{" "}
                in partnership with <strong>UNDP</strong>, the survey was
                designed to generate comprehensive, nationally representative
                data on charcoal production, trade, consumption, and pricing —
                data essential for evidence-based energy policy in a country
                where charcoal remains the dominant cooking fuel for millions of
                households.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                The survey's scope was extraordinary in its breadth and
                ambition:
              </p>
              <ol>
                <li>
                  <strong>Household surveys</strong> in{" "}
                  <strong>2,880 households</strong> spanning 28 districts from
                  Kampala in the centre to Gulu in the north, Kabale in the
                  south-west, and Kaabong in the far north-east.
                </li>
                <li>
                  <strong>Institutional surveys</strong> in{" "}
                  <strong>500 facilities</strong> including hospitals, schools,
                  prisons, military barracks, and SMEs.
                </li>
                <li>
                  <strong>Fuel price market surveys, KIIs, and FGDs</strong>{" "}
                  across all 28 districts.
                </li>
                <li>
                  <strong>Road traffic surveys</strong> capturing charcoal
                  movement patterns along major transport corridors.
                </li>
                <li>
                  <strong>Cross-border trade surveys</strong> documenting the
                  flow of charcoal across Uganda's national boundaries.
                </li>
                <li>
                  <strong>Charcoal quality testing</strong> and on-site
                  assessments characterising the range of charcoal products in
                  circulation.
                </li>
              </ol>
              <h2 className="art-subheading">Significance</h2>
              <p>
                The National Charcoal Survey generated the most comprehensive
                picture of Uganda's charcoal economy that had ever existed — a
                critical evidence base for policymakers seeking to reduce
                deforestation, improve charcoal efficiency, and transition
                households toward cleaner cooking alternatives. Its findings fed
                directly into national energy policy formulation and set the
                benchmark data against which future progress could be measured.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's large-scale energy surveys,
                contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
